import api from "./api";

const mobileAppVersionService = {
  list: () => api.get("/mobile-app-versions"),
  save: (payload) => api.put("/mobile-app-versions", payload),
};

export default mobileAppVersionService;
